export const TOOLTIP_BUTTON_CLASS = "js-menu-tooltip";
